import { stringify } from 'query-string';
import { format, differenceInHours, differenceInMinutes, subHours } from 'date-fns';
import padCharsStart from 'lodash/fp/padCharsStart';

const padNumber = padCharsStart('0')(2);

const formatCalendarDate = (date) => {
  const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes());
  return format(utcDate, "yyyyMMdd'T'HHmmss'Z'");
};

const formatCalendarDuration = (endDate, startDate) => {
  const hours = differenceInHours(endDate, startDate);
  const minutes = differenceInMinutes(subHours(endDate, hours), startDate);
  return `${padNumber(hours)}:${padNumber(minutes)}`;
};

const GOOGLE_CALENDAR_URL = 'https://calendar.google.com/calendar/render';

// See https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/master/services/google.md
export const createGoogleCalendarLink = ({ startDate, endDate, location, title, description }) => {
  const query = stringify({
    action: 'TEMPLATE',
    dates: `${formatCalendarDate(startDate)}/${formatCalendarDate(endDate)}`,
    location,
    text: title,
    details: description,
  });

  return `${GOOGLE_CALENDAR_URL}?${query}`;
};

const YAHOO_CALENDAR_URL = 'https://calendar.yahoo.com';

// See https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/master/services/yahoo.md
export const createYahooCalendarLink = ({ startDate, endDate, location, title, description }) => {
  const query = stringify({
    v: '60',
    view: 'd',
    type: '20',
    title,
    st: formatCalendarDate(startDate),
    dur: formatCalendarDuration(endDate, startDate),
    desc: description,
    in_loc: location,
  });

  return `${YAHOO_CALENDAR_URL}?${query}`;
};

// iCalendar file format. See https://en.wikipedia.org/wiki/ICalendar
export const createIcs = ({ startDate, endDate, location, title, description, url }) => {
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'BEGIN:VEVENT',
    'URL:' + url,
    'DTSTART:' + formatCalendarDate(startDate),
    'DTEND:' + formatCalendarDate(endDate),
    'SUMMARY:' + title,
    'DESCRIPTION:' + description.replace(/\n/g, '\\n'),
    'LOCATION:' + location,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\n');
};
